import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private msalService: MsalService, private authService: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean> {
    const account = this.msalService.instance.getActiveAccount();

    // Step 1: If no account, definitely not logged in
    if (!account) {
      this.router.navigate(['/login']);
      return false;
    }

    try {
      // Step 2: Try acquiring a token silently to validate session
      const result = await this.msalService.instance.acquireTokenSilent({
        account,
        scopes: ['user.read'], // put your actual scopes here
      });

      // Step 3: Token acquired successfully, user is logged in
      if (result?.accessToken) {
        return true;
      }

      // If for some reason token is missing, redirect
      this.router.navigate(['/login']);
      return false;
    } catch (error) {
      // Step 4: Handle expired or invalid tokens
      if (error instanceof InteractionRequiredAuthError) {
        console.warn('Silent token acquisition failed — user interaction required.');
      } else {
        console.error('AuthGuard token check error:', error);
      }

      this.router.navigate(['/login']);
      return false;
    }
  }
}
